import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App.tsx';
import { APP_CONFIG, printEnvInfo } from '@/config/env';
import { initVersionCheck, startVersionPolling, checkOnVisible } from '@/utils/versionCheck';

// 打印环境信息（仅在开发环境）
printEnvInfo();

// 设置页面标题
document.title = APP_CONFIG.title;

// 获取根元素
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('根元素 #root 未找到，请检查 index.html 文件');
}

// 创建 React 根实例并渲染应用
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// 开发环境下的热更新支持
if (import.meta.env.DEV) {
  console.log('🚀 Light X For Creative启动成功');
}

// 初始化版本检查
if (!import.meta.env.DEV) {
  // 初始化当前版本
  initVersionCheck().then(() => {
    // 启动版本轮询检查，每5分钟检查一次
    startVersionPolling(5 * 60 * 1000, true);
  });
  // 用户回到页面时立即检查一次更新
  checkOnVisible();
}
